{
  "avatar": {
    "upload": "Upload Avatar",
    "change": "Change Avatar",
    "delete": "Delete Avatar",
    "cropImage": "Crop Image",
    "zoom": "Zoom",
    "uploadSuccess": "Avatar uploaded successfully",
    "uploadError": "Failed to upload avatar",
    "deleteSuccess": "Avatar deleted successfully",
    "deleteError": "Failed to delete avatar",
    "invalidFile": "Invalid file type or size",
    "fileReadError": "Failed to read file"
  },
  "logo": {
    "prepareError": "Failed to prepare logo upload",
    "uploadSuccess": "Logo uploaded successfully",
    "uploadError": "Failed to upload logo",
    "deleteSuccess": "Logo deleted successfully",
    "deleteError": "Failed to delete logo"
  }
}
